// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1e-ZK","large":"styles_large__1PrxG"};